import { ts } from '_core';

import { getName, validate } from './helpers';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.SIGNAL_CUMULATIVE_RETURNS,
    title: 'Cumulative Returns',
    helpLabel: '85dx88rz',
    form: true,
    neededFiles: ['signal_cumulative_returns'],
    tags: [
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.SIGNAL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.ALPHA_MODEL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.COMMON_ALPHA_MODEL,
    ],

    validate,
    getName,
  },
] satisfies ts.types.analysis.WidgetConfig[];
